module.exports = __webpack_public_path__ + "static/media/gdpr-partneri.0479f127.pdf";